export default "__VITE_ASSET__I26S57yk__"